export default {"src":"/_next/static/image/public/images/ic_male_blue.f462bdf28fcdbf06d91dc7899dbd2820.svg","height":24,"width":25};